let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("axIcs")).then(() => parcelRequire('a5z0r'));